import { Column } from '@ant-design/charts'
import { ColumnConfig } from '@ant-design/plots/es/components/column'
import { Flex, Spin } from 'antd'
import React, { useMemo } from 'react'

import { ChatterSalesDetail, TrendsEarning } from '@/model/analytics'

import EarningGrowthTooltip from '../common/earning-growth-tooltip'
import SectionTitle from '../section-title'

export interface ChatterOverviewSalesProps {
  loading: boolean
  salesDetails?: ChatterSalesDetail[]
}

export default function ChatterOverviewSales({
  loading,
  salesDetails,
}: ChatterOverviewSalesProps) {
  const config = useMemo(() => {
    const config: ColumnConfig = {
      data: salesDetails || [],
      xField: 'dateStr',
      yField: 'earnings',
      axis: {
        x: {
          labelAutoRotate: false,
        },
      },
      height: 320,
      style: {
        maxWidth: 100,
        minHeight: 1,
        fill: '#3A5C40',
        fillOpacity: 1,
      },
      // extend data with tooltip
      tooltip(data: TrendsEarning) {
        return { origin: data }
      },
      interaction: {
        tooltip: {
          render: (
            _: object,
            options: { title: string; items: { origin: TrendsEarning }[] },
          ) => {
            // fix tooltip package [Object object] issue
            // https://github.com/ant-design/ant-design-charts/issues/2487
            return (
              <div data-type="react">
                <EarningGrowthTooltip {...options.items[0].origin} />
              </div>
            )
          },
        },
      },
    }

    return config
  }, [salesDetails])

  return (
    <Spin spinning={loading}>
      <Flex vertical gap={8}>
        <SectionTitle
          title="Chatter sales"
          tooltip="Chatter sales growth and trends determined by your team's sales settings"
        />
        <Column {...config} />
      </Flex>
    </Spin>
  )
}
